export const fields = {
  addOnName: {
    id: 'addOnName',
    type: 'text',
    required: true
  },
  addOnDescription: {
    id: 'addOnDescription',
    type: 'text',
    required: false
  },
  selectCurrency: {
    id: 'selectCurrency'
  },
  nameInput: {
    id: 'nameInput',
    type: 'text',
    required: true
  },
  priceInput: {
    id: 'priceInput',
    type: 'number'
  },
  capacityInput: {
    id: 'capacityInput',
    type: 'number'
  },
  skuInput: {
    id: 'skuInput',
    type: 'text',
    required: false
  },
  maxQuantityInput: {
    id: 'maxQuantityInput',
    type: 'number',
    required: false
  },
  minQuantityInput: {
    id: 'minQuantityInput',
    type: 'number',
    required: false
  },
  addOnHostPaysCommission: {
    id: 'addOnHostPaysCommission',
    type: 'boolean'
  },
  addOnPostPurchaseMessage: {
    id: 'addOnPostPurchaseMessage',
    type: 'text'
  }
};
